import React from 'react';
import InventoryReports from '../../pages/InventoryReports';

const InventoryReport = () => {
  return <InventoryReports />;
};

export default InventoryReport; 